export default __webpack_public_path__ + "static/question-img-01f240914437260292c6a3491312ef50.jpg";